import { render, staticRenderFns } from "./RestartConfirmationPage.vue?vue&type=template&id=64d9a81b&scoped=true&"
import script from "./RestartConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./RestartConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./RestartConfirmationPage.vue?vue&type=style&index=0&id=64d9a81b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9a81b",
  null
  
)

export default component.exports